module.exports = __webpack_public_path__ + "static/media/chef-avatar-2@2x.64740048.png";